import { definirNbs, definirPessoa, isPessoaValida } from './regrasInfo'
import { getSeguro, getSeguroPromise, postSeguroPromise } from '../shared/helper/requests'
import { limparCachePedidos } from 'apps/requerimentos/consultar/actions'
import { MSG_ERRO_SERVIDOR } from '../shared/constantes/mensagens';
import { openLoginPage, openLogoutUrl } from 'platformImpl'
import { removeNotificationToken } from '../apps/notificacao/registroNotificacao'
import { trackProfileORA } from '../shared/helper/tracker'
import map from 'lodash/map'
import store from '../store'

import {
  decodificarToken,
  tokenAutorizado,
  tokensMesmoCPF,
  getAgeFromStringDate,
  existsBeneficio,
  isRotaAberta,
} from './helper';

import _ from 'lodash'

import history from '../history';

export const abrirGovbr = () => {
  
  localStorage.removeItem('ifs_auth');
  localStorage.removeItem('ifs_ts');

  openLoginPage();

}

export const confirmarLogin = () => {
  return async (dispatch) => {
    let data = decodificarToken(localStorage.getItem('ifs_auth'))    
    if (data != null) {
      let miToken = undefined
      let dataMiToken = undefined
      if (
        tokensMesmoCPF(localStorage.getItem('ifs_auth'), localStorage.getItem('miToken'))
      ) {
        miToken = localStorage.getItem('miToken')
        dataMiToken = decodificarToken(miToken)
      }

      dispatch({
        type: 'USUARIO_LOGADO',
        payload: {
          cpf: data?.sub,
          token: localStorage.getItem('ifs_auth'),
          miToken: miToken,
          selos: data.scope,
          validadeToken: localStorage.getItem('ifs_ts'),
          cpfProcurador: data?.agentAccount?.cpf,
          isProcurador: data?.agent,
          agentAccount: data?.agentAccount,          
          nome: dataMiToken?.pessoa?.nome,                  
          nomeRepresentado: dataMiToken?.pessoa?.nome,
          nomeProcurador: data?.agentAccount?.name,
        },
        usuarioAutorizado: tokenAutorizado(localStorage.getItem('ifs_auth')),
      })

      // Entra no fluxo sem selo kba
      if (!tokenAutorizado(localStorage.getItem('ifs_auth'))) { 
        await getSeguroPromise('cnisservicos/dadosDivergentes')
          .then(async res => {

            dispatch(setUsuarioAutorizado(true));

            // Exibe informação de não encontrado no CNIS
            if (res?.data?.naoCadastrado) {              
              dispatch(tratarDadosDivergentes(res.data));
              history.push('/');
              return dispatch({ type: 'BUSCA_NBS_ERRO' });
            }

          })
          .catch(err => {
            return dispatch(tratarFalhaRequisicaoDadosDivergentes(err));
          })

          return null;
      }

      dispatch(buscarInfo());
      let payload = decodificarToken(localStorage.getItem('ifs_auth'));
      const refreshPedidos = localStorage.getItem("refreshPedidos") === "true";      
      if(refreshPedidos){
        limparCachePedidos();
        localStorage.removeItem("refreshPedidos");
      }
      return getSeguro(
        dispatch,
        `usuarioservices/info/${payload?.sub}?refreshPedidos=${refreshPedidos}`,
        receberNbs,
        receberNbsErro
      )
    }
  }
}

export const atualizarSituacaoVersao = (data) => {
  return {
    type: 'ATUALIZACAO_APP',
    payload: data,
  }
}

const setConfiguracoesUsuario = (data) => ({
  type: 'SET_CONFIG',
  payload: data
})

export const receberNbs = (data) => {

  if (data.configuracoes) {
    store.dispatch(setConfiguracoesUsuario(JSON.parse(data.configuracoes)))
  }

  localStorage.setItem('miToken', data.miToken);

  let tokenLido = decodificarToken(data.miToken);

  validarMesmoCpf(tokenLido);

  if (definirPessoa(tokenLido.pessoa) === "not found") {
    buscarDadosDivergentes();
  }
  return concluirBuscaNbs(data.miToken);
}

export const concluirBuscaNbs = (miToken) => {
  let dados = decodificarToken(miToken);
  let auth = decodificarToken(localStorage.getItem('ifs_auth'));

  let beneficios = null
  
  if(isPessoaValida(dados.pessoa) && dados.nbsJson === 'erro') {
    let {usuario, nbsJson} = store.getState().session;
    if( nbsJson && nbsJson !== 'erro') {
      dados.nbs = usuario && Array.isArray(usuario.nb) && usuario.nb.length > 0 ? usuario.nb : undefined;
      dados.nbsJson = nbsJson;
    }else{
      dados.pessoa = 'erro';
    }
  }else  if (dados.nbsJson && dados.nbsJson !== 'erro') {
    try {
      dados.nbsJson = JSON.parse(dados.nbsJson)
      beneficios = dados.nbsJson.listaBeneficios
      if (beneficios && beneficios.length) {
        dados.nbs = map(beneficios, 'numero')
      }
    } catch (ex) {
      console.debug(ex);
    }
  }

  initTrackProfile(dados);

  return {
    type: 'BUSCA_NBS_CONCLUIDA',
    payload: {
      nbs: definirNbs(dados.nbs),
      pessoaCnis: definirPessoa(dados.pessoa),
      miToken: miToken,
      nbsJson: dados.nbsJson,
      perfil: dados.perfil,
      cpf: auth.sub
    },
  }
}

const validarMesmoCpf = (dados) => {
  let auth = decodificarToken(localStorage.getItem('ifs_auth'));

  let mitokenPessoa = typeof dados.pessoa !== 'string' 
    ? JSON.parse(dados.pessoa) 
    : dados.pessoa

  if (
    typeof mitokenPessoa !== 'string' &&
    Object.hasOwn(mitokenPessoa, 'cpf') &&
    Number(auth.sub) !== mitokenPessoa.cpf
  ) {
    infoSecurity(auth.sub, mitokenPessoa.cpf);
    deslogarUsuario();
  }
}

const initTrackProfile = (data) => {
  let pessoa = definirPessoa(data.pessoa);

  if (!sessionStorage.getItem('initTrack')) {
    sessionStorage.setItem('initTrack', true);

    let userAge = getAgeFromStringDate(pessoa.dataNascimento);
    if (userAge) {
      trackProfileORA('Iniciar App - Idade', userAge);
    }

    trackProfileORA(
      'Status do Benefício',
      existsBeneficio(data.nbsJson) ? 'Benefício Ativo' : 'Sem Benefício Ativo'
    );
  }
}

const setUsuarioAutorizado = (value) => ({
  type: 'SET_USUARIO_AUTORIZADO',
  payload: value
})

export const receberNbsErro = () => ({
  type: 'BUSCA_NBS_ERRO',
})

export const getInfo = () => {
  const refreshPedidos = localStorage.getItem("refreshPedidos") === "true";  
  if(refreshPedidos){
    limparCachePedidos();
    localStorage.removeItem("refreshPedidos");
  }
  return (dispatch) => {
    let payload = decodificarToken(localStorage.getItem('ifs_auth'))
    const url = `usuarioservices/info/${payload?.sub}?refreshPedidos=${refreshPedidos}`;
    return getSeguro(
      dispatch,
      url,
      receberNbs,
      receberNbsErro
    )
  }
}

export const criarInscricaoMeuINSS = () => {
  return (dispatch) => {        
    let payload = decodificarToken(localStorage.getItem('ifs_auth'))        
    const url = `usuarioservices/criarInscricao/${payload?.sub}`;
    return getSeguro(
      dispatch,
      url,
      (data) => {        
        //verifica se eh procurador (nao pode fazer inscricao)
        if (payload?.agent){
          return {type: "DADOS_INSCRICAO_PROCURADOR"}
        }

        if (data.configuracoes) {
          dispatch(setConfiguracoesUsuario(JSON.parse(data.configuracoes)))
        }
      
        let tokenLido = decodificarToken(data.miToken);        
        const pessoa = definirPessoa(tokenLido.pessoa);

        if(isPessoaValida(tokenLido.pessoa) || tokenLido.pessoa === 'not found'){
          let pessoaINSS = pessoa;
          localStorage.setItem('miToken', data.miToken);
          return {type: "DADOS_INSCRICAO_INSS", payload: {pessoaINSS, miToken: data.miToken}}
        }else{
          return { type: "DADOS_INSCRICAO_INSS_ERRO", payload: {pessoa, hasMessageError: pessoa?.hasOwnProperty("mensagens")}};
        }
      },
      (erro) => ({type: "DADOS_INSCRICAO_INSS_ERRO"})
    )
  }
}

export const acessoNegadoProcurador = () => {
  return {type: "DADOS_ATUALIZACAO_INSS_PROCURADOR"}
}

export const infoSecurity = (cpfSolicitado, cpfEnviado) => {
  return (dispatch) => {
    return postSeguroPromise(dispatch, 'usuarioservices/inconsistencia', {
      cpfSolicitado,
      cpfEnviado,
    })
  }
}

export const buscarInfo = () => ({
  type: 'BUSCA_NBS',
})

export const deslogarUsuario = () => {
  let rotaAberta = isRotaAberta(window.location.hash);
  if(!rotaAberta){    
    removeNotificationToken()
    openLogoutUrl()
  }
  return [{ type: 'USUARIO_DESLOGADO' }]
}

export const tratarDadosDivergentes = (dados) => {
  let dadosDivergentes = []

  if (dados) {
    if (dados.naoCadastrado) {
      dadosDivergentes.push({
        naoCadastrado: true
      })
    }
    if (dados.dataNascimento) {
      dadosDivergentes.push({
        tipo: 'Data de Nascimento',
        INSS: dados.dataNascimento.INSS || "não informada",
        ReceitaFederal: dados.dataNascimento.ReceitaFederal || "não informada",
      })
    }
    if (dados.nomeCompleto) {
      dadosDivergentes.push({
        tipo: 'Nome Completo',
        INSS: dados.nomeCompleto.INSS || "não informado",
        ReceitaFederal: dados.nomeCompleto.ReceitaFederal || "não informado",
      })
    }
    if (dados.nomeMae) {
      dadosDivergentes.push({
        tipo: 'Nome da Mãe',
        INSS: dados.nomeMae.INSS || "não informado",
        ReceitaFederal: dados.nomeMae.ReceitaFederal || "não informado",
      })
    }
  }  
  
  return {
    type: 'DADOS_DIVERGENTES',
    payload: dadosDivergentes,
  }
};

export const buscarDadosDivergentes = () => {
    return getSeguro(
      store.dispatch,
      `cnisservicos/dadosDivergentes`,
      tratarDadosDivergentes,
      tratarFalhaRequisicaoDadosDivergentes
    )
};

export const tratarFalhaRequisicaoDadosDivergentes = (error) => {
  let message = MSG_ERRO_SERVIDOR
  return {
    type: 'ERRO_BUSCA_DADOS_DIVERGENTES',
    payload: {
      erro: error.response?.status,
      message: message,
    },
  }
};

export const resetMiToken = () => dispatch => {    
    localStorage.removeItem("miToken");
    dispatch(getInfo());
    return { type: 'RESET_MITOKEN' };
  }

export const avancarInscricaoINSS = () => dispatch => {
  dispatch(buscarInfo());
  dispatch(getInfo());
}